import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/authService';

export const AuthCallback: React.FC = () => {
  const { checkAuth } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the token from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const refreshToken = urlParams.get('refresh_token');

        console.log('[AuthCallback] Processing callback...');
        console.log('[AuthCallback] Token present:', !!token);
        console.log('[AuthCallback] Refresh token present:', !!refreshToken);

        if (token) {
          // Store the tokens
          console.log('[AuthCallback] Storing token in localStorage...');
          authService.setToken(token);
          if (refreshToken) {
            localStorage.setItem('bri_refresh_token', refreshToken);
          }

          // Set cross-subdomain cookie for microservices
          const cookieManager = authService.getCookieManager();
          cookieManager.setCrossSubdomainAuthCookie({
            jwt: token,
            sessionID: `session_${Math.random().toString(36).substr(2, 9)}_${Date.now()}`,
            userID: 'authenticated',
            audience: 'BRI'
          });
          console.log('[AuthCallback] Set cross-subdomain cookie');

          // Update auth state
          console.log('[AuthCallback] Calling checkAuth...');
          await checkAuth();
          console.log('[AuthCallback] checkAuth completed');

          // Redirect to the main app
          console.log('[AuthCallback] Redirecting to /');
          window.location.href = '/';
        } else {
          // No token found, redirect to login
          console.error('[AuthCallback] No token found in callback');
          window.location.href = '/';
        }
      } catch (error) {
        console.error('[AuthCallback] Auth callback error:', error);
        window.location.href = '/';
      }
    };

    handleCallback();
  }, [checkAuth]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="background.default"
    >
      <CircularProgress size={60} color="primary" />
      <Typography variant="h6" sx={{ mt: 2 }} color="text.primary">
        Completing sign in...
      </Typography>
    </Box>
  );
};

export default AuthCallback;

